module.exports = __webpack_public_path__ + "static/media/Element_Icon_Message.ef94a7fb.svg";